<template>
    <div>

    </div>
</template>

<script>
import auth from '../auth'
import Axios from 'axios';
import { config } from '../config';
import GoogleAuth from './GoogleAuth';

export default {
    computed: {
        ...amfx.map('session', 'user,apiToken')
    },
    async created() {
        let token = sessionStorage.getItem('authToken');
        await auth.token(token);
        let query = this.$route.query || {};
        
        if(query.employerId) {
            this.$router.push(`/employer/${query.employerId}/main`);
        }
        else if(query.redirect) {
            window.location.href = query.redirect;
        }
        else {
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/framework/Auth.vue